import { safeStorage } from "../utils/storage";

export const sessionStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    try {
      const savedValue = safeStorage.getItem(key);
      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }
    } catch (error) {
      console.error(`[Storage] ${key} 복원 실패:`, error);
      safeStorage.removeItem(key);
    }

    onSet((newValue, _, isReset) => {
      try {
        isReset
          ? safeStorage.removeItem(key)
          : safeStorage.setItem(key, JSON.stringify(newValue));
      } catch (error) {
        console.error(`[Storage] ${key} 저장 실패:`, error);
      }
    });
  };
